var _slicedToArray = require("/vercel/path0/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/vercel/path0/node_modules/gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/vercel/path0/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (n, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : (n = "undefined" != typeof globalThis ? globalThis : n || self).EmblaCarouselReact = t(n.React);
}(this, function (n) {
  "use strict";

  function t(n) {
    return function (n) {
      return "[object Object]" === Object.prototype.toString.call(n);
    }(n) || Array.isArray(n);
  }

  function e(n, r) {
    var o = Object.keys(n),
        i = Object.keys(r);
    if (o.length !== i.length) return !1;
    return JSON.stringify(Object.keys(n.breakpoints || {})) === JSON.stringify(Object.keys(r.breakpoints || {})) && o.every(function (o) {
      var i = n[o],
          c = r[o];
      return "function" == typeof i ? "".concat(i) == "".concat(c) : t(i) && t(c) ? e(i, c) : i === c;
    });
  }

  function r(n) {
    return n.concat().sort(function (n, t) {
      return n.name > t.name ? 1 : -1;
    }).map(function (n) {
      return n.options;
    });
  }

  function o(n) {
    return "number" == typeof n;
  }

  function i(n) {
    return "string" == typeof n;
  }

  function c(n) {
    return "boolean" == typeof n;
  }

  function u(n) {
    return "[object Object]" === Object.prototype.toString.call(n);
  }

  function s(n) {
    return Math.abs(n);
  }

  function a(n) {
    return Math.sign(n);
  }

  function l(n, t) {
    return s(n - t);
  }

  function f(n) {
    return h(n).map(Number);
  }

  function d(n) {
    return n[p(n)];
  }

  function p(n) {
    return Math.max(0, n.length - 1);
  }

  function m(n, t) {
    return t === p(n);
  }

  function g(n) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Array.from(Array(n), function (n, e) {
      return t + e;
    });
  }

  function h(n) {
    return Object.keys(n);
  }

  function y(n, t) {
    return [n, t].reduce(function (n, t) {
      return h(t).forEach(function (e) {
        var r = n[e],
            o = t[e],
            i = u(r) && u(o);
        n[e] = i ? y(r, o) : o;
      }), n;
    }, {});
  }

  function x(n, t) {
    return void 0 !== t.MouseEvent && n instanceof t.MouseEvent;
  }

  function b() {
    var n = [];
    var t = {
      add: function add(e, r, o) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
          passive: !0
        };
        var c;
        if ("addEventListener" in e) e.addEventListener(r, o, i), c = function c() {
          return e.removeEventListener(r, o, i);
        };else {
          var _n = e;
          _n.addListener(o), c = function c() {
            return _n.removeListener(o);
          };
        }
        return n.push(c), t;
      },
      clear: function clear() {
        n = n.filter(function (n) {
          return n();
        });
      }
    };
    return t;
  }

  function v(n, t, e, r) {
    var o = b(),
        i = 1e3 / 60;
    var c = null,
        u = 0,
        a = 0;

    function l(n) {
      c || (c = n);
      var o = n - c;

      for (c = n, u += o; u >= i;) {
        e(), u -= i;
      }

      var f = s(u / i);
      r(f), a && t.requestAnimationFrame(l);
    }

    function f() {
      t.cancelAnimationFrame(a), c = null, u = 0, a = 0;
    }

    return {
      init: function init() {
        o.add(n, "visibilitychange", function () {
          n.hidden && (c = null, u = 0);
        });
      },
      destroy: function destroy() {
        f(), o.clear();
      },
      start: function start() {
        a || (a = t.requestAnimationFrame(l));
      },
      stop: f,
      update: e,
      render: r
    };
  }

  function S() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var e = s(n - t);

    function r(t) {
      return t < n;
    }

    function o(n) {
      return n > t;
    }

    function i(n) {
      return r(n) || o(n);
    }

    return {
      length: e,
      max: t,
      min: n,
      constrain: function constrain(e) {
        return i(e) ? r(e) ? n : t : e;
      },
      reachedAny: i,
      reachedMax: o,
      reachedMin: r,
      removeOffset: function removeOffset(n) {
        return e ? n - e * Math.ceil((n - t) / e) : n;
      }
    };
  }

  function w(n, t, e) {
    var _S = S(0, n),
        r = _S.constrain,
        o = n + 1;

    var i = c(t);

    function c(n) {
      return e ? s((o + n) % o) : r(n);
    }

    function u() {
      return i;
    }

    function a() {
      return w(n, u(), e);
    }

    var l = {
      get: u,
      set: function set(n) {
        return i = c(n), l;
      },
      add: function add(n) {
        return a().set(u() + n);
      },
      clone: a
    };
    return l;
  }

  function E(n, t, e, r, o, i, u, f, d, p, m, g, h, y, v, w, E, O, L, D) {
    var I = n.cross,
        A = ["INPUT", "SELECT", "TEXTAREA"],
        M = {
      passive: !1
    },
        T = b(),
        k = b(),
        F = S(50, 225).constrain(v.measure(20)),
        P = {
      mouse: 300,
      touch: 400
    },
        z = {
      mouse: 500,
      touch: 600
    },
        H = w ? 43 : 25;
    var j = !1,
        R = 0,
        V = 0,
        N = !1,
        B = !1,
        C = !1,
        q = !1;

    function G(n) {
      var e = u.readPoint(n),
          r = u.readPoint(n, I),
          o = l(e, R),
          c = l(r, V);

      if (!B && !q) {
        if (!n.cancelable) return $(n);
        if (B = o > c, !B) return $(n);
      }

      var s = u.pointerMove(n);
      o > E && (C = !0), m.useFriction(.3).useDuration(1), d.start(), i.add(t.apply(s)), n.preventDefault();
    }

    function $(n) {
      var e = g.byDistance(0, !1).index !== h.get(),
          r = u.pointerUp(n) * (w ? z : P)[q ? "mouse" : "touch"],
          o = function (n, t) {
        var e = h.add(-1 * a(n)),
            r = g.byDistance(n, !w).distance;
        return w || s(n) < F ? r : O && t ? .5 * r : g.byIndex(e.get(), 0).distance;
      }(t.apply(r), e),
          i = function (n, t) {
        if (0 === n || 0 === t) return 0;
        if (s(n) <= s(t)) return 0;
        var e = l(s(n), s(t));
        return s(e / n);
      }(r, o),
          c = H - 10 * i,
          f = L + i / 50;

      B = !1, N = !1, k.clear(), m.useDuration(c).useFriction(f), p.distance(o, !w), q = !1, y.emit("pointerUp");
    }

    function U(n) {
      C && (n.stopPropagation(), n.preventDefault());
    }

    return {
      init: function init(n) {
        if (!D) return;

        function t(t) {
          (c(D) || D(n, t)) && function (n) {
            var t = x(n, o);
            if (q = t, t && 0 !== n.button) return;
            if (function (n) {
              var t = n.nodeName || "";
              return A.includes(t);
            }(n.target)) return;
            C = w && t && !n.buttons && j, j = l(i.get(), f.get()) >= 2, N = !0, u.pointerDown(n), m.useFriction(0).useDuration(0), i.set(f), function () {
              var n = q ? r : e;
              k.add(n, "touchmove", G, M).add(n, "touchend", $).add(n, "mousemove", G, M).add(n, "mouseup", $);
            }(), R = u.readPoint(n), V = u.readPoint(n, I), y.emit("pointerDown");
          }(t);
        }

        var s = e;
        T.add(s, "dragstart", function (n) {
          return n.preventDefault();
        }, M).add(s, "touchmove", function () {}, M).add(s, "touchend", function () {}).add(s, "touchstart", t).add(s, "mousedown", t).add(s, "touchcancel", $).add(s, "contextmenu", $).add(s, "click", U, !0);
      },
      pointerDown: function pointerDown() {
        return N;
      },
      destroy: function destroy() {
        T.clear(), k.clear();
      }
    };
  }

  function O(n, t) {
    var e, r;

    function o(n) {
      return n.timeStamp;
    }

    function i(e, r) {
      var o = "client" + ("x" === (r || n.scroll) ? "X" : "Y");
      return (x(e, t) ? e : e.touches[0])[o];
    }

    return {
      pointerDown: function pointerDown(n) {
        return e = n, r = n, i(n);
      },
      pointerMove: function pointerMove(n) {
        var t = i(n) - i(r),
            c = o(n) - o(e) > 170;
        return r = n, c && (e = n), t;
      },
      pointerUp: function pointerUp(n) {
        if (!e || !r) return 0;
        var t = i(r) - i(e),
            c = o(n) - o(e),
            u = o(n) - o(r) > 170,
            a = t / c;
        return c && !u && s(a) > .1 ? a : 0;
      },
      readPoint: i
    };
  }

  function L(n, t, e, r, o, i, u) {
    var a,
        l,
        f = [],
        d = !1;

    function p(n) {
      return o.measureSize(u.measure(n));
    }

    return {
      init: function init(o) {
        if (!i) return;
        l = p(n), f = r.map(p), a = new ResizeObserver(function (u) {
          d || (c(i) || i(o, u)) && function (i) {
            var _iterator = _createForOfIteratorHelper(i),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _c = _step.value;

                var _i = _c.target === n,
                    _u = r.indexOf(_c.target),
                    _a = _i ? l : f[_u];

                if (s(p(_i ? n : r[_u]) - _a) >= .5) {
                  e.requestAnimationFrame(function () {
                    o.reInit(), t.emit("resize");
                  });
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }(u);
        }), [n].concat(r).forEach(function (n) {
          return a.observe(n);
        });
      },
      destroy: function destroy() {
        a && a.disconnect(), d = !0;
      }
    };
  }

  function D(n, t, e, r, o) {
    var i = o.measure(10),
        c = o.measure(50),
        u = S(.1, .99);
    var a = !1;
    return {
      constrain: function constrain(o) {
        if (a || !n.reachedAny(e.get()) || !n.reachedAny(t.get())) return;
        var l = n.reachedMin(t.get()) ? "min" : "max",
            f = s(n[l] - t.get()),
            d = e.get() - t.get(),
            p = u.constrain(f / c);
        e.subtract(d * p), !o && s(d) < i && (e.set(n.constrain(e.get())), r.useDuration(25).useBaseFriction());
      },
      toggleActive: function toggleActive(n) {
        a = !n;
      }
    };
  }

  function I(n, t, e, r) {
    var o = t.min + .1,
        i = t.max + .1,
        _S2 = S(o, i),
        c = _S2.reachedMin,
        u = _S2.reachedMax;

    return {
      loop: function loop(t) {
        if (!function (n) {
          return 1 === n ? u(e.get()) : -1 === n && c(e.get());
        }(t)) return;
        var o = n * (-1 * t);
        r.forEach(function (n) {
          return n.add(o);
        });
      }
    };
  }

  function A(n, t, e, r, o) {
    var i = r.reachedAny,
        c = r.removeOffset,
        u = r.constrain;

    function l(n) {
      return n.concat().sort(function (n, t) {
        return s(n) - s(t);
      })[0];
    }

    function f(t, r) {
      var o = [t, t + e, t - e];
      if (!n) return o[0];
      if (!r) return l(o);
      var i = o.filter(function (n) {
        return a(n) === r;
      });
      return i.length ? l(i) : d(o) - e;
    }

    return {
      byDistance: function byDistance(e, r) {
        var a = o.get() + e,
            _ref = function (e) {
          var r = n ? c(e) : u(e),
              o = t.map(function (n) {
            return n - r;
          }).map(function (n) {
            return f(n, 0);
          }).map(function (n, t) {
            return {
              diff: n,
              index: t
            };
          }).sort(function (n, t) {
            return s(n.diff) - s(t.diff);
          }),
              i = o[0].index;
          return {
            index: i,
            distance: r
          };
        }(a),
            l = _ref.index,
            d = _ref.distance,
            p = !n && i(a);

        return !r || p ? {
          index: l,
          distance: e
        } : {
          index: l,
          distance: e + f(t[l] - d, 0)
        };
      },
      byIndex: function byIndex(n, e) {
        return {
          index: n,
          distance: f(t[n] - o.get(), e)
        };
      },
      shortcut: f
    };
  }

  function M(n) {
    var t = n;

    function e(n) {
      return o(n) ? n : n.get();
    }

    return {
      get: function get() {
        return t;
      },
      set: function set(n) {
        t = e(n);
      },
      add: function add(n) {
        t += e(n);
      },
      subtract: function subtract(n) {
        t -= e(n);
      }
    };
  }

  function T(n, t, e) {
    var r = "x" === n.scroll ? function (n) {
      return "translate3d(".concat(n, "px,0px,0px)");
    } : function (n) {
      return "translate3d(0px,".concat(n, "px,0px)");
    },
        o = e.style;
    var i = !1;
    return {
      clear: function clear() {
        i || (o.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
      },
      to: function to(n) {
        i || (o.transform = r(t.apply(n)));
      },
      toggleActive: function toggleActive(n) {
        i = !n;
      }
    };
  }

  function k(n, t, e, r, o, i, c, u, s, a) {
    var l = .5,
        d = f(i),
        p = f(i).reverse(),
        m = function () {
      var n = u[0];
      return y(h(p, n), r, !1);
    }().concat(function () {
      var n = e - u[0] - 1;
      return y(h(d, n), -r, !0);
    }());

    function g(n, t) {
      return n.reduce(function (n, t) {
        return n - i[t];
      }, t);
    }

    function h(n, t) {
      return n.reduce(function (n, e) {
        return g(n, t) > 0 ? n.concat([e]) : n;
      }, []);
    }

    function y(i, u, f) {
      var d = function (n) {
        return c.map(function (t, r) {
          return {
            start: t - o[r] + l + n,
            end: t + e - l + n
          };
        });
      }(u);

      return i.map(function (e) {
        var o = f ? 0 : -r,
            i = f ? r : 0,
            c = f ? "end" : "start",
            u = d[e][c];
        return {
          index: e,
          loopPoint: u,
          slideLocation: M(-1),
          translate: T(n, t, a[e]),
          target: function target() {
            return s.get() > u ? o : i;
          }
        };
      });
    }

    return {
      canLoop: function canLoop() {
        return m.every(function (_ref2) {
          var n = _ref2.index;
          return g(d.filter(function (t) {
            return t !== n;
          }), e) <= .1;
        });
      },
      clear: function clear() {
        m.forEach(function (n) {
          return n.translate.clear();
        });
      },
      loop: function loop() {
        m.forEach(function (n) {
          var t = n.target,
              e = n.translate,
              r = n.slideLocation,
              o = t();
          o !== r.get() && (e.to(o), r.set(o));
        });
      },
      loopPoints: m
    };
  }

  function F(n, t, e) {
    var r,
        o = !1;
    return {
      init: function init(i) {
        e && (r = new MutationObserver(function (n) {
          o || (c(e) || e(i, n)) && function (n) {
            var _iterator2 = _createForOfIteratorHelper(n),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _e = _step2.value;

                if ("childList" === _e.type) {
                  i.reInit(), t.emit("slidesChanged");
                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }(n);
        }), r.observe(n, {
          childList: !0
        }));
      },
      destroy: function destroy() {
        r && r.disconnect(), o = !0;
      }
    };
  }

  function P(n, t, e, r) {
    var o = {};
    var i,
        c = null,
        u = null,
        s = !1;
    return {
      init: function init() {
        i = new IntersectionObserver(function (n) {
          s || (n.forEach(function (n) {
            var e = t.indexOf(n.target);
            o[e] = n;
          }), c = null, u = null, e.emit("slidesInView"));
        }, {
          root: n.parentElement,
          threshold: r
        }), t.forEach(function (n) {
          return i.observe(n);
        });
      },
      destroy: function destroy() {
        i && i.disconnect(), s = !0;
      },
      get: function get() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        if (n && c) return c;
        if (!n && u) return u;

        var t = function (n) {
          return h(o).reduce(function (t, e) {
            var r = parseInt(e),
                i = o[r].isIntersecting;
            return (n && i || !n && !i) && t.push(r), t;
          }, []);
        }(n);

        return n && (c = t), n || (u = t), t;
      }
    };
  }

  function z(n, t, e, r, i, c, u, a, l, m) {
    var g = n.startEdge,
        h = n.endEdge,
        y = o(r);
    return {
      groupSlides: function groupSlides(n) {
        return y ? function (n, t) {
          return f(n).filter(function (n) {
            return n % t == 0;
          }).map(function (e) {
            return n.slice(e, e + t);
          });
        }(n, r) : function (n) {
          return n.length ? f(n).reduce(function (r, o) {
            var f = d(r) || 0,
                y = 0 === f,
                x = o === p(n),
                b = c[g] - u[f][g],
                v = c[g] - u[o][h],
                S = !i && y ? t.apply(a) : 0;
            return s(v - (!i && x ? t.apply(l) : 0) - (b + S)) > e + m && r.push(o), x && r.push(n.length), r;
          }, []).map(function (t, e, r) {
            var o = Math.max(r[e - 1] || 0);
            return n.slice(o, t);
          }) : [];
        }(n);
      }
    };
  }

  function H(n, t, e, r, c, u, l) {
    var h = u.align,
        y = u.axis,
        x = u.direction,
        H = u.startIndex,
        j = u.loop,
        R = u.duration,
        V = u.dragFree,
        N = u.dragThreshold,
        B = u.inViewThreshold,
        C = u.slidesToScroll,
        q = u.skipSnaps,
        G = u.containScroll,
        $ = u.watchResize,
        U = u.watchSlides,
        W = u.watchDrag,
        J = {
      measure: function measure(n) {
        var t = n.offsetTop,
            e = n.offsetLeft,
            r = n.offsetWidth,
            o = n.offsetHeight;
        return {
          top: t,
          right: e + r,
          bottom: t + o,
          left: e,
          width: r,
          height: o
        };
      }
    },
        Q = J.measure(t),
        X = e.map(J.measure),
        Y = function (n) {
      var t = "rtl" === n ? -1 : 1;
      return {
        apply: function apply(n) {
          return n * t;
        }
      };
    }(x),
        K = function (n, t) {
      var e = "y" === n ? "y" : "x";
      return {
        scroll: e,
        cross: "y" === n ? "x" : "y",
        startEdge: "y" === e ? "top" : "rtl" === t ? "right" : "left",
        endEdge: "y" === e ? "bottom" : "rtl" === t ? "left" : "right",
        measureSize: function measureSize(n) {
          var t = n.width,
              r = n.height;
          return "x" === e ? t : r;
        }
      };
    }(y, x),
        Z = K.measureSize(Q),
        _ = function (n) {
      return {
        measure: function measure(t) {
          return n * (t / 100);
        }
      };
    }(Z),
        nn = function (n, t) {
      var e = {
        start: function start() {
          return 0;
        },
        center: function center(n) {
          return r(n) / 2;
        },
        end: r
      };

      function r(n) {
        return t - n;
      }

      return {
        measure: function measure(r, o) {
          return i(n) ? e[n](r) : n(t, r, o);
        }
      };
    }(h, Z),
        tn = !j && !!G,
        en = j || !!G,
        _ref3 = function (n, t, e, r, o, i) {
      var c = n.measureSize,
          u = n.startEdge,
          a = n.endEdge,
          l = e[0] && o,
          f = function () {
        if (!l) return 0;
        var n = e[0];
        return s(t[u] - n[u]);
      }(),
          p = function () {
        if (!l) return 0;
        var n = i.getComputedStyle(d(r));
        return parseFloat(n.getPropertyValue("margin-".concat(a)));
      }(),
          g = e.map(c),
          h = e.map(function (n, t, e) {
        var r = !t,
            o = m(e, t);
        return r ? g[t] + f : o ? g[t] + p : e[t + 1][u] - n[u];
      }).map(s);

      return {
        slideSizes: g,
        slideSizesWithGaps: h,
        startGap: f,
        endGap: p
      };
    }(K, Q, X, e, en, c),
        rn = _ref3.slideSizes,
        on = _ref3.slideSizesWithGaps,
        cn = _ref3.startGap,
        un = _ref3.endGap,
        sn = z(K, Y, Z, C, j, Q, X, cn, un, 2),
        _ref4 = function (n, t, e, r, o) {
      var i = n.startEdge,
          c = n.endEdge,
          u = o.groupSlides,
          a = u(r).map(function (n) {
        return d(n)[c] - n[0][i];
      }).map(s).map(t.measure),
          l = r.map(function (n) {
        return e[i] - n[i];
      }).map(function (n) {
        return -s(n);
      }),
          f = u(l).map(function (n) {
        return n[0];
      }).map(function (n, t) {
        return n + a[t];
      });
      return {
        snaps: l,
        snapsAligned: f
      };
    }(K, nn, Q, X, sn),
        an = _ref4.snaps,
        ln = _ref4.snapsAligned,
        fn = -d(an) + d(on),
        _ref5 = function (n, t, e, r, o) {
      var i = S(-t + n, 0),
          c = e.map(function (n, t) {
        var r = !t,
            o = m(e, t);
        return r ? i.max : o ? i.min : i.constrain(n);
      }).map(function (n) {
        return parseFloat(n.toFixed(3));
      }),
          u = function () {
        var n = c[0],
            t = d(c);
        return S(c.lastIndexOf(n), c.indexOf(t) + 1);
      }();

      return {
        snapsContained: function () {
          if (t <= n + o) return [i.max];
          if ("keepSnaps" === r) return c;
          var e = u.min,
              s = u.max;
          return c.slice(e, s);
        }(),
        scrollContainLimit: u
      };
    }(Z, fn, ln, G, 2),
        dn = _ref5.snapsContained,
        pn = _ref5.scrollContainLimit,
        mn = tn ? dn : ln,
        _ref6 = function (n, t, e) {
      var r = t[0];
      return {
        limit: S(e ? r - n : d(t), r)
      };
    }(fn, mn, j),
        gn = _ref6.limit,
        hn = w(p(mn), H, j),
        yn = hn.clone(),
        xn = f(e),
        bn = v(r, c, function () {
      return function (_ref8) {
        var n = _ref8.dragHandler,
            t = _ref8.scrollBody,
            e = _ref8.scrollBounds,
            r = _ref8.options.loop;
        r || e.constrain(n.pointerDown()), t.seek();
      }(Fn);
    }, function (n) {
      return function (_ref9, l) {
        var n = _ref9.scrollBody,
            t = _ref9.translate,
            e = _ref9.location,
            r = _ref9.offsetLocation,
            o = _ref9.scrollLooper,
            i = _ref9.slideLooper,
            c = _ref9.dragHandler,
            u = _ref9.animation,
            s = _ref9.eventHandler,
            a = _ref9.options.loop;
        var f = n.velocity(),
            d = n.settled();
        d && !c.pointerDown() && (u.stop(), s.emit("settle")), d || s.emit("scroll"), r.set(e.get() - f + f * l), a && (o.loop(n.direction()), i.loop()), t.to(r.get());
      }(Fn, n);
    }),
        vn = mn[hn.get()],
        Sn = M(vn),
        wn = M(vn),
        En = M(vn),
        On = function (n, t, e, r, o) {
      var i = 0,
          c = 0,
          u = r,
          l = o,
          f = n.get(),
          d = 0;

      function p(n) {
        return u = n, g;
      }

      function m(n) {
        return l = n, g;
      }

      var g = {
        direction: function direction() {
          return c;
        },
        duration: function duration() {
          return u;
        },
        velocity: function velocity() {
          return i;
        },
        seek: function seek() {
          var t = e.get() - n.get();
          var r = 0;
          return u ? (i += t / u, i *= l, f += i, n.add(i), r = f - d) : (i = 0, n.set(e), r = t), c = a(r), d = f, g;
        },
        settled: function settled() {
          return s(e.get() - t.get()) < .001;
        },
        useBaseFriction: function useBaseFriction() {
          return m(o);
        },
        useBaseDuration: function useBaseDuration() {
          return p(r);
        },
        useFriction: m,
        useDuration: p
      };
      return g;
    }(Sn, wn, En, R, .68),
        Ln = A(j, mn, fn, gn, En),
        Dn = function (n, t, e, r, o, i) {
      function c(r) {
        var c = r.distance,
            u = r.index !== t.get();
        o.add(c), c && n.start(), u && (e.set(t.get()), t.set(r.index), i.emit("select"));
      }

      return {
        distance: function distance(n, t) {
          c(r.byDistance(n, t));
        },
        index: function index(n, e) {
          var o = t.clone().set(n);
          c(r.byIndex(o.get(), e));
        }
      };
    }(bn, hn, yn, Ln, En, l),
        In = function (n) {
      var t = n.max,
          e = n.length;
      return {
        get: function get(n) {
          return e ? (n - t) / -e : 0;
        }
      };
    }(gn),
        An = b(),
        Mn = P(t, e, l, B),
        _ref7 = function (n, t, e, r, o, i) {
      var c = o.groupSlides,
          u = r.min,
          s = r.max;
      return {
        slideRegistry: function () {
          var r = c(i),
              o = !n || "keepSnaps" === t;
          return 1 === e.length ? [i] : o ? r : r.slice(u, s).map(function (n, t, e) {
            var r = !t,
                o = m(e, t);
            return r ? g(d(e[0]) + 1) : o ? g(p(i) - d(e)[0] + 1, d(e)[0]) : n;
          });
        }()
      };
    }(tn, G, mn, pn, sn, xn),
        Tn = _ref7.slideRegistry,
        kn = function (n, t, e, r, i, c) {
      var u = 0;

      function s(n) {
        "Tab" === n.code && (u = new Date().getTime());
      }

      function a(s) {
        c.add(s, "focus", function () {
          if (new Date().getTime() - u > 10) return;
          n.scrollLeft = 0;
          var c = t.indexOf(s),
              a = e.findIndex(function (n) {
            return n.includes(c);
          });
          o(a) && (i.useDuration(0), r.index(a, 0));
        }, {
          passive: !0,
          capture: !0
        });
      }

      return {
        init: function init() {
          c.add(document, "keydown", s, !1), t.forEach(a);
        }
      };
    }(n, e, Tn, Dn, On, An),
        Fn = {
      ownerDocument: r,
      ownerWindow: c,
      eventHandler: l,
      containerRect: Q,
      slideRects: X,
      animation: bn,
      axis: K,
      direction: Y,
      dragHandler: E(K, Y, n, r, c, En, O(K, c), Sn, bn, Dn, On, Ln, hn, l, _, V, N, q, .68, W),
      eventStore: An,
      percentOfView: _,
      index: hn,
      indexPrevious: yn,
      limit: gn,
      location: Sn,
      offsetLocation: wn,
      options: u,
      resizeHandler: L(t, l, c, e, K, $, J),
      scrollBody: On,
      scrollBounds: D(gn, Sn, En, On, _),
      scrollLooper: I(fn, gn, wn, [Sn, wn, En]),
      scrollProgress: In,
      scrollSnapList: mn.map(In.get),
      scrollSnaps: mn,
      scrollTarget: Ln,
      scrollTo: Dn,
      slideLooper: k(K, Y, Z, fn, rn, on, an, mn, wn, e),
      slideFocus: kn,
      slidesHandler: F(t, l, U),
      slidesInView: Mn,
      slideIndexes: xn,
      slideRegistry: Tn,
      slidesToScroll: sn,
      target: En,
      translate: T(K, Y, t)
    };

    return Fn;
  }

  var j = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "trimSnaps",
    direction: "ltr",
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: !1,
    dragThreshold: 10,
    loop: !1,
    skipSnaps: !1,
    duration: 25,
    startIndex: 0,
    active: !0,
    watchDrag: !0,
    watchResize: !0,
    watchSlides: !0
  };

  function R(n) {
    function t(n, t) {
      return y(n, t || {});
    }

    var e = {
      mergeOptions: t,
      optionsAtMedia: function optionsAtMedia(e) {
        var r = e.breakpoints || {},
            o = h(r).filter(function (t) {
          return n.matchMedia(t).matches;
        }).map(function (n) {
          return r[n];
        }).reduce(function (n, e) {
          return t(n, e);
        }, {});
        return t(e, o);
      },
      optionsMediaQueries: function optionsMediaQueries(t) {
        return t.map(function (n) {
          return h(n.breakpoints || {});
        }).reduce(function (n, t) {
          return n.concat(t);
        }, []).map(n.matchMedia);
      }
    };
    return e;
  }

  function V(n, t, e) {
    var r = n.ownerDocument,
        o = r.defaultView,
        c = R(o),
        u = function (n) {
      var t = [];
      return {
        init: function init(e, r) {
          return t = r.filter(function (_ref10) {
            var t = _ref10.options;
            return !1 !== n.optionsAtMedia(t).active;
          }), t.forEach(function (t) {
            return t.init(e, n);
          }), r.reduce(function (n, t) {
            return Object.assign(n, _defineProperty({}, t.name, t));
          }, {});
        },
        destroy: function destroy() {
          t = t.filter(function (n) {
            return n.destroy();
          });
        }
      };
    }(c),
        s = b(),
        a = function () {
      var n = {};
      var t;

      function e(t) {
        return n[t] || [];
      }

      var r = {
        init: function init(n) {
          t = n;
        },
        emit: function emit(n) {
          return e(n).forEach(function (e) {
            return e(t, n);
          }), r;
        },
        off: function off(t, o) {
          return n[t] = e(t).filter(function (n) {
            return n !== o;
          }), r;
        },
        on: function on(t, o) {
          return n[t] = e(t).concat([o]), r;
        }
      };
      return r;
    }(),
        l = c.mergeOptions,
        f = c.optionsAtMedia,
        d = c.optionsMediaQueries,
        p = a.on,
        m = a.off,
        g = a.emit,
        h = A;

    var y,
        x,
        v,
        S,
        w = !1,
        E = l(j, V.globalOptions),
        O = l(E),
        L = [];

    function D(t) {
      var e = H(n, v, S, r, o, t, a);

      if (t.loop && !e.slideLooper.canLoop()) {
        return D(Object.assign({}, t, {
          loop: !1
        }));
      }

      return e;
    }

    function I(t, e) {
      w || (E = l(E, t), O = f(E), L = e || L, function () {
        var _O = O,
            t = _O.container,
            e = _O.slides,
            r = i(t) ? n.querySelector(t) : t;
        v = r || n.children[0];
        var o = i(e) ? v.querySelectorAll(e) : e;
        S = [].slice.call(o || v.children);
      }(), y = D(O), d([E].concat(_toConsumableArray(L.map(function (_ref11) {
        var n = _ref11.options;
        return n;
      })))).forEach(function (n) {
        return s.add(n, "change", A);
      }), O.active && (y.translate.to(y.location.get()), y.animation.init(), y.slidesInView.init(), y.slideFocus.init(), y.eventHandler.init(F), y.resizeHandler.init(F), y.slidesHandler.init(F), y.options.loop && y.slideLooper.loop(), v.offsetParent && S.length && y.dragHandler.init(F), x = u.init(F, L)));
    }

    function A(n, t) {
      var e = k();
      M(), I(l({
        startIndex: e
      }, n), t), a.emit("reInit");
    }

    function M() {
      y.dragHandler.destroy(), y.eventStore.clear(), y.translate.clear(), y.slideLooper.clear(), y.resizeHandler.destroy(), y.slidesHandler.destroy(), y.slidesInView.destroy(), y.animation.destroy(), u.destroy(), s.clear();
    }

    function T(n, t, e) {
      O.active && !w && (y.scrollBody.useBaseFriction().useDuration(!0 === t ? 0 : O.duration), y.scrollTo.index(n, e || 0));
    }

    function k() {
      return y.index.get();
    }

    var F = {
      canScrollNext: function canScrollNext() {
        return y.index.add(1).get() !== k();
      },
      canScrollPrev: function canScrollPrev() {
        return y.index.add(-1).get() !== k();
      },
      containerNode: function containerNode() {
        return v;
      },
      internalEngine: function internalEngine() {
        return y;
      },
      destroy: function destroy() {
        w || (w = !0, s.clear(), M(), a.emit("destroy"));
      },
      off: m,
      on: p,
      emit: g,
      plugins: function plugins() {
        return x;
      },
      previousScrollSnap: function previousScrollSnap() {
        return y.indexPrevious.get();
      },
      reInit: h,
      rootNode: function rootNode() {
        return n;
      },
      scrollNext: function scrollNext(n) {
        T(y.index.add(1).get(), n, -1);
      },
      scrollPrev: function scrollPrev(n) {
        T(y.index.add(-1).get(), n, 1);
      },
      scrollProgress: function scrollProgress() {
        return y.scrollProgress.get(y.location.get());
      },
      scrollSnapList: function scrollSnapList() {
        return y.scrollSnapList;
      },
      scrollTo: T,
      selectedScrollSnap: k,
      slideNodes: function slideNodes() {
        return S;
      },
      slidesInView: function slidesInView() {
        return y.slidesInView.get();
      },
      slidesNotInView: function slidesNotInView() {
        return y.slidesInView.get(!1);
      }
    };
    return I(t, e), setTimeout(function () {
      return a.emit("init");
    }, 0), F;
  }

  function N() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var i = n.useRef(t),
        c = n.useRef(o),
        _n$useState = n.useState(),
        _n$useState2 = _slicedToArray(_n$useState, 2),
        u = _n$useState2[0],
        s = _n$useState2[1],
        _n$useState3 = n.useState(),
        _n$useState4 = _slicedToArray(_n$useState3, 2),
        a = _n$useState4[0],
        l = _n$useState4[1],
        f = n.useCallback(function () {
      u && u.reInit(i.current, c.current);
    }, [u]);

    return n.useEffect(function () {
      if ("undefined" != typeof window && window.document && window.document.createElement && a) {
        V.globalOptions = N.globalOptions;

        var _n2 = V(a, i.current, c.current);

        return s(_n2), function () {
          return _n2.destroy();
        };
      }

      s(void 0);
    }, [a, s]), n.useEffect(function () {
      e(i.current, t) || (i.current = t, f());
    }, [t, f]), n.useEffect(function () {
      (function (n, t) {
        if (n.length !== t.length) return !1;
        var o = r(n),
            i = r(t);
        return o.every(function (n, t) {
          return e(n, i[t]);
        });
      })(c.current, o) || (c.current = o, f());
    }, [o, f]), [l, u];
  }

  return V.globalOptions = void 0, N.globalOptions = void 0, N;
});